import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfettiLeft = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 45,
	height: 44,
	fill: "none",
	viewBox: "0 0 45 44",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_15397_22437)",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: props.color,
			d: "M11.9428 -2.12134L16.2464 1.35626L24.469 1.35627C24.469 1.35627 16.0544 4.69953 11.9431 16.5003C7.83184 28.3012 10.6355 34.9999 10.6355 34.9999L-0.582783 23.0047C-0.582783 23.0047 -5.22246 27.9626 -1.08487 14.83C3.05273 1.6975 11.9428 -2.12134 11.9428 -2.12134Z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: props.color,
			d: "M43.3676 39.2922L40.9458 41.6208L40.3214 46.5743C40.3214 46.5743 38.9463 41.2512 32.1493 37.8784C25.3523 34.5056 21.1039 35.686 21.1039 35.686L29.182 29.8386C29.182 29.8386 26.5475 26.667 34.1448 30.1568C41.742 33.6466 43.3676 39.2922 43.3676 39.2922Z"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_15397_22437",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 45,
			height: 44,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgConfettiLeft);
export default ForwardRef;
